import type { Patient } from 'fhir/r4';
import React, { useState } from 'react';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import type { MenuItemProps } from 'semantic-ui-react';

import TransferLine from './transferLine';
import UnknownCallLog from './unknownCallLog';
import VMCallLog from './voicemail-log-zoom';
import ZendeskUnassigned from './zendesk-unassigned';
//import { useAmazonConnect } from 'contexts/AmazonConnectContext';

type ConnectProps = {
  onPatientSelected: (selectedPatient?: Patient, taskId?: string, patientId?: string) => void;
};

const Connect: React.FC<ConnectProps> = ({ onPatientSelected: _onPatientSelected }) => {
  //const { setIsMessagesTab } = useAmazonConnect();
  const [activeItem, setActiveItem] = useState('Unknown Communications');

  const handleMenuItemClick = (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => {
    e.preventDefault();

    setActiveItem(data.name!);
  };

  /* useEffect(() => {
    setIsMessagesTab(true);
  }, [setIsMessagesTab]); */

  return (
    <div>
      <Segment>
        <Menu pointing>
          <Menu.Item
            key="calllog"
            name="Unknown Communications"
            active={activeItem === 'Unknown Communications'}
            onClick={handleMenuItemClick}
          />
          <Menu.Item
            key="transferline"
            name="Transfer Line"
            active={activeItem === 'Transfer Line'}
            onClick={handleMenuItemClick}
          />
          <Menu.Item
            key="calllog"
            name="Voice Mail Inbox"
            active={activeItem === 'Voice Mail Inbox'}
            onClick={handleMenuItemClick}
          />
          {/* <Menu.Item
            key="calllog"
            name="Call Abandoned Inbox"
            active={activeItem === 'Call Abandoned Inbox'}
            onClick={handleMenuItemClick}
          /> */}
          {/* <Menu.Item
            key="vmlog"
            name="Voice Mail Tickets"
            active={activeItem === 'Voice Mail Tickets'}
            onClick={handleMenuItemClick}
          />
          <Menu.Item
            key="emailsms"
            name="Email/SMS Tickets"
            active={activeItem === 'Email/SMS Tickets'}
            onClick={handleMenuItemClick}
          /> */}
          <Menu.Item
            key="calllog"
            name="Archived Communications"
            active={activeItem === 'Archived Communications'}
            onClick={handleMenuItemClick}
          />
          {/* TEMP: Zendesk Unassigned Communications */}
          <Menu.Item
            key="zendesk"
            name="Zendesk Unassigned"
            active={activeItem === 'Zendesk Unassigned'}
            onClick={handleMenuItemClick}
          />
        </Menu>
        <Grid padded="horizontally">
          <Grid.Row divided>
            {activeItem === 'Unknown Communications' && (
              <Grid.Column width={16}>
                <UnknownCallLog archived={false} />
              </Grid.Column>
            )}
            {activeItem === 'Transfer Line' && (
              <Grid.Column width={16}>
                <TransferLine />
              </Grid.Column>
            )}
            {activeItem === 'Voice Mail Inbox' && (
              <Grid.Column width={16}>
                <VMCallLog />
              </Grid.Column>
            )}

            {
              //Disabled until Ruth needs this metric.
              /* {activeItem === 'Call Abandoned Inbox' && (
              <Grid.Column width={16}>
                <AbandonedCallLog />
              </Grid.Column>
            )} */
            }
            {/* {activeItem === 'Voice Mail Tickets' && (
              <Grid.Column width={16}>
                <VoicemailLog onPatientSelect={onPatientSelected} />
              </Grid.Column>
            )}
            {activeItem === 'Email/SMS Tickets' && (
              <Grid.Column width={16}>
                <EmailSMSLog onPatientSelect={onPatientSelected} />
              </Grid.Column>
            )} */}

            {activeItem === 'Archived Communications' && (
              <Grid.Column width={16}>
                <UnknownCallLog archived={true} />
              </Grid.Column>
            )}

            {/* TEMP: Zendesk Unassigned Communications */}
            {activeItem === 'Zendesk Unassigned' && (
              <Grid.Column width={16}>
                <ZendeskUnassigned />
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );
};
export default Connect;
